import { inject, Pipe, PipeTransform } from '@angular/core';
import { BaryContactUtil } from 'app/shared/util/bary-contact-util';
import { AbstractTransport } from 'models/abstract-transport.model';
import { Contact } from '../../models/contact.model';

@Pipe({
  name: 'transportContact',
  standalone: true,
})
export class TransportContactPipe implements PipeTransform {
  readonly #contactUtil = inject(BaryContactUtil);

  transform(value: AbstractTransport, options: { pickup?: boolean; delivery?: boolean }): string {
    if (!options.pickup && !options.delivery) {
      return '';
    }
    let result = '';
    if (options.pickup) {
      const pickupContact = new Contact();
      pickupContact.civility = value.pickupContactCivility;
      pickupContact.lastName = value.pickupContactLastName;
      pickupContact.firstName = value.pickupContactFirstName;
      pickupContact.mail = value.pickupContactMail;
      pickupContact.phone = value.pickupContactPhone;

      result += this.#contactUtil.writeContact(pickupContact);
    }
    if (options.delivery) {
      const deliveryContact = new Contact();
      deliveryContact.civility = value.deliveryContactCivility;
      deliveryContact.lastName = value.deliveryContactLastName;
      deliveryContact.firstName = value.deliveryContactFirstName;
      deliveryContact.mail = value.deliveryContactMail;
      deliveryContact.phone = value.deliveryContactPhone;

      result += this.#contactUtil.writeContact(deliveryContact);
    }
    return result;
  }
}
